import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useRfmGroupList } from '@/modules/rfm/group/model/list';
import { ROUTE_NAME_RFM } from '@/modules/rfm/router';
import { rfmService } from '@/services/rfm';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useRfmPersona() {
    const router = useAppRouter();
    const route = useRoute();
    const crudAction = useCrudActions();

    const { rfmGroupOptions, fetchRfmGroupAll } = useRfmGroupList();
    const model = reactive({
        id: StringUtils.toNumber(route.params.id),
        name: '',
        groupId: StringUtils.toNumber(route.query.groupId)
    });

    const validations = {
        name: { required },
        groupId: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        canExecute: () => model.id != null,
        request: () => rfmService.persona.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_RFM.PERSONA.INDEX, query: { groupId: model.groupId } })
    });

    const actions = {
        create: crudAction.confirmAndExecute({
            validator: v$,
            request: () => rfmService.persona.create(model.name, model.groupId),
            onSuccess: () => router.push({ name: ROUTE_NAME_RFM.PERSONA.INDEX, query: { groupId: model.groupId } })
        }),

        update: crudAction.confirmAndExecute({
            validator: v$,
            request: () => rfmService.persona.update(model.id, model.name),
            onSuccess: () => router.push({ name: ROUTE_NAME_RFM.PERSONA.INDEX, query: { groupId: model.groupId } })
        }),
        remove: crudAction.confirmAndRemove({
            request: () => rfmService.persona.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_RFM.PERSONA.INDEX, query: { groupId: model.groupId } })
        })
    };

    return { model, v$, fetch, rfmGroupOptions, fetchRfmGroupAll, actions };
}
